const cardIndexGrid = [
    {
        selector: '[data-react="cardIndexGrid"]',
        path: { filename: 'App' },
    },
];

export { cardIndexGrid };
